<template>
	<page>
		<module enable-flex>
			<m-operate>
				<c-button power="b_product_type_add" color="sys" icon="add" @click="addHandle(null)">新增一级类目</c-button>
				<c-button color="red" icon="release" @click="releaseHandle()">发布类目</c-button>
			</m-operate>

			<c-table ref="table" :paging="false">
				<c-table-column type="expand" label="类目名称" name="type_name" add-button="添加子类目" expand-limit="2"
					width="220" @expand="loadChildren" @add="addHandle">
				</c-table-column>

				<c-table-column label="服务类型" name="id" width="70" v-if="systemConfig.is_virtual_product == 'ON'">
					<template v-slot="{data}">
						<span v-if="data.is_virtual==0">实物服务</span>
						<span v-if="data.is_virtual==1" style="color: blue">虚拟服务</span>
					</template>
				</c-table-column>

				<c-table-column label="图片" width="50">
					<template v-slot="{data, expandData}">
						<div v-if="expandData.level==0 && data.img_url" class="group-img flex-center">
							<c-image :src="data.img_url" preview size="25" style="margin-right:0px;"></c-image>
						</div>
					</template>
				</c-table-column>

				<c-table-column label="爆款设置" width="430">
					<template v-slot="{data}">
						<span v-if="data.is_hot==1">
							代理售价：<strong style="color:green">￥{{ data.sale_price }}</strong>元；
							单个地市代理数量：<strong style="color:green">{{ data.max_agency_count }}</strong>个；
							爆款佣金比例：<strong style="color: blue">{{data.hot_type_ratio}} %</strong>
						</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column label="专业代理" width="240">
					<template v-slot="row">
						<span v-if="row.data.is_professional_agency==1">
							佣金比例<span style="color: red">{{ row.data.professional_agency_ratio }}%</span>；
							<a v-if="row.data.professional_agency_count > 0" class="s-link" @click="showProfAgency(row)">
								已配置专业代理({{ row.data.professional_agency_count }})
							</a>
							<span v-else style="color: darkgrey">未配置专业代理</span>；
						</span>
						<span v-else style="color: darkgrey">-</span>
					</template>
				</c-table-column>

				<c-table-column label="类目ID" name="id" width="65"></c-table-column>

				<c-table-column type="sort" label="排序" @sort="sortHandle"></c-table-column>

        <c-table-column
            label="体验版是否显示"
            name="trial_is_display"
            width="150"
        >
          <template v-slot="row">
            <c-switch v-if="auth('b_product_type_edit')" :value="row.data.trial_is_display == 1" text="显示,隐藏"
                      @change="changeTrialDisplay(row, arguments[0], arguments[1],arguments[2])"></c-switch>
            <strong v-else-if="row.data.trial_is_display == 0" style="color: darkgray">隐藏</strong>
            <strong v-else-if="row.data.trial_is_display == 1" style="color: green">显示</strong>
          </template>

        </c-table-column>

				<c-table-column type="button" fixed="right" label="操作" width="200" limit=3>
					<template v-slot="row">
						<c-table-button power="b_product_type_edit" @click="editHandle(row)">编辑</c-table-button>
						<c-table-button power="b_product_type_edit" @click="editTypeOrderFlow(row)">下单配置</c-table-button>
						<c-table-button power="b_product_type_edit" v-if="row.expandData.level == 1 && row.data.is_professional_agency==1" @click="editProfessionalAgency(row)">添加专业代理</c-table-button>
						<!-- <c-table-button power="b_product_type_edit" @click="specConfig(row)">规格配置</c-table-button> -->
						<c-table-button power="b_product_type_del" @click="deleteHandle(row)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>

		<c-dialog ref="dialog" :title="classifyEditTitle" width="650" height="500" @resolve="addChild">
			<c-form ref="classifyEdit">
				<c-form-item type="input" label="类目名称" name="type_name" required></c-form-item>
				<c-form-item type="radio" label="服务类型" v-show="systemConfig.is_virtual_product == 'ON' && editLevel==0"
					v-model="isVirtual" name="is_virtual" :options="isVirtualOptions" :word="isVirtualWord"
					:disabled="editState || editLevel > 0"></c-form-item>
				<c-form-item type="image" v-show="editLevel == 0" label="类目图片" oss name="img_url"
					file-word="建议尺寸: 88X88px，支持jpg、jpeg、png格式`" required></c-form-item>
				<c-form-item type="radio" label="是否爆款" v-show="editLevel==1" v-model="isHot" name="is_hot"
					:options="hotOptions" :word="isHotWord"></c-form-item>
				<c-form title="爆款代理设置" v-show="isHot == 1">
					<c-form-item type="number" :limit="[0.01,99999]" decimal="2" label="身份售价"
						name="sale_price" input-unit="元" required word="请填写购买该爆款类目需支付的金额"></c-form-item>
					<c-form-item type="number"  :limit="[1,9999]" decimal="0" label="开通数量"
						name="max_agency_count" input-unit="个" required word="单个地市，该爆款类目最多允可售次数"></c-form-item>
					<c-form-item type="number" :limit="[0.01,50]" decimal="2" label="佣金比例"
						name="hot_type_ratio" input-unit="%" required word="购买了该爆款类目的代理商可获得订单金额的比例"></c-form-item>
					<c-form-item type="radio" v-show="editLevel==1" label="专业代理"
						v-model="isProfessionalAgency" name="is_professional_agency" required
						:options="professionalAgencyOptions"
						word="配置可选，则普通代理可以邀请当前类目配置的专业代理协助其进行服务，专业代理可按订单金额比例获得佣金"></c-form-item>
					<c-form-item type="number" v-show="editLevel==1 && isProfessionalAgency"
						:limit="[0.01,50]" decimal="2" label="佣金比例" name="professional_agency_ratio" input-unit="%"
						required word="请填写专业代理提供服务后，可获得的佣金比例"></c-form-item>
				</c-form>
			</c-form>
		</c-dialog>
		
		<!--编辑服务类目下单相关内容-->
		<c-dialog ref="editTypeOrderFlowDialog" :title="typeOrderFlowTitle" width="900" height="550" @resolve="editOrderFlowHandle">
			<c-form ref="classifyOrderEdit">
				<c-form-item type="checkbox" label="所需材料" name="order_materials" v-model="orderMaterials" :options="orderMaterialsOptions" required word="购买该类目服务所需提交的材料信息，该提示将在下单时展示在订单确认页面，如果二级类目配置了提示信息则使用，未配置则自动继承一级类目的配置"></c-form-item>
				<c-form-item label="服务项目" required>
					<div class="flex" style="margin-top: 10px;">
						<c-button color="sys" icon="add" style="width:120px;" @click="addOrderFlow()">添加项目</c-button>
						<p class="flex-grow" style="color: darkgrey;margin: 0 10px 10px;">
							服务项目将按顺序展示在订单信息中，完成一项点亮一项，用于标记服务进度；
							如果某项服务标记为需要支付，则客户必须先完成付款，服务商才会开始服务
						</p>
					</div>
					<c-table v-model="orderFlowList" border height="auto">
						<c-table-column label="服务项目名称" width="300">
							<template v-slot="{data}">
								<c-input type="input" v-model="data.flow_name" maxlength="30" width="280"></c-input>
							</template>
						</c-table-column>
						<c-table-column label="是否需支付" width="110">
							<template v-slot="row">
								<c-select v-model="row.data.payment_required" width="80" :options="paymentRequiredOptions" @change="changePaymentRequired(row)"></c-select>
							</template>
						</c-table-column>
						<c-table-column label="费用比例（%）" width="110">
							<template v-slot="{data}">
								<c-input type="number" v-model="data.flow_ratio" :disabled="data.payment_required == 0" decimal="2" :limit="[0,100]" width="80"></c-input>
							</template>
						</c-table-column>
						<c-table-column type="sort" label="排序" width="100"
							@sort="sortOrderFollowHandle"></c-table-column>
						<c-table-column fixed="none" type="button" label="操作" width="80">
							<template v-slot="row">
								<c-table-button @click="row.remove()">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
		</c-dialog>
		
		<!--配置规格-->
		<c-dialog ref="specConfigDialog" title="配置规格" width="900" height="581" @resolve="specConfigHandle">
			<c-form ref="specConfig" :label-align="false">
				<c-form-item type="radio" label="是否允许对单个SKU图片进行修改" name="is_support_sku_img"
					:options="skuImageOptions"></c-form-item>
				<c-form-item :label="false">
					<div class="spec-list">
						<div v-for="(spec, i) in specList" :key="i" class="spec">
							<div class="flex">
								<label class="spec-label">规格名</label>
								<div>
									<div class="flex-center-cross">
										<input v-model="spec.name" class="spec-name" type="text"
											@change="specNameVerify(spec, i)">
										<c-checkbox :checked="spec.image"
											@change="specImageCheck($event, spec)">配图</c-checkbox>
									</div>
									<div class="spec-item-list flex-wrap">
										<div v-for="(item, j) in spec.itemList" :key="j"
											class="spec-item flex-center-cross">
											<input v-model="item.value" class="spec-item-value flex-grow" type="text"
												@change="specValueVerify(item, spec.itemList)">
											<a class="spec-item-remove tf tf-clear" @click="removeItem(spec, j)"></a>
										</div>
									</div>
									<c-button background="#4A528D" icon="add"
										@click="addSpecItem(spec)">添加规格值</c-button>
								</div>
								<div v-show="specList.length > 1" class="spec-handle flex">
									<a class="spec-handle-item" @click="sortSpec(i, 'up')"><i
											class="tf tf-sort-up"></i></a>
									<a class="spec-handle-item" @click="sortSpec(i, 'down')"><i
											class="tf tf-sort-down"></i></a>
									<a class="spec-handle-item" @click="removeSpec(i)"><i class="tf tf-trash"></i></a>
								</div>
							</div>
						</div>
						<c-button size="m" radius="2" @click="addSpec">新增规格项</c-button>
					</div>
				</c-form-item>
			</c-form>
		</c-dialog>
		<!--已配置的【专业代理列表】-->
		<c-dialog ref="professionalAgencyDialog" :title="professionalAgencyTitle" width="900" :button="false">
			<m-search ref="searchProfAgency" @search="searchProfAgency">
				<c-form ref="form" inline>
					<c-form-item type="input" label="专业代理手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="专业代理昵称" name="nick_name"></c-form-item>
				</c-form>
			</m-search>

			<c-table ref="profAgencyTable" height="500">

				<c-table-column label="专业代理头像/昵称" name="head_photo" width="200">
					<template v-slot="{data}">
						<div class="flex-center-cross">
							<c-image :src="data.head_photo" preview size="25" style="margin-right: 10px;"></c-image>
							<div>
								<span>{{ data.nick_name }}</span></br>
							</div>
						</div>
					</template>
				</c-table-column>

				<c-table-column label="专业代理手机号" name="user_manage_mobilephone" width="110">
					<template v-slot="{data}">
						<span>{{ data.user_manage_mobilephone || '-' }}</span>
					</template>
				</c-table-column>

				<c-table-column label="专业代理等级" name="user_level_name" width="90">
					<template v-slot="{data}">
						<span v-if="data.user_level_name && data.user_level_name!='' && data.user_level > 0"
							style="color:blue">{{ data.user_level_name }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column type="button" fixed="right" label="操作" width="100">
					<template v-slot="{data}">
						<c-table-button @click="removeProfAgency(data)">移除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		<!--选择会员-->
		<member-user-selector ref="memberUserSelector" multiple @resolve="selectHandle($event)"></member-user-selector>
	</page>
</template>

<script>
	import {
		mapGetters,
		mapState
	} from "vuex";
	import memberUserSelector from "@/components/service/member_user_selector.vue";

	export default {
		name: 'm_product_type',
		components: {
			memberUserSelector
		},

		data() {
			return {
				editState: false,
				classifyEditTitle: '编辑类目',
				typeOrderFlowTitle: '类目下单所需信息配置',
				skuImageOptions: [{
					name: '是',
					value: 1
				}, {
					name: '否（建议）',
					value: 0
				}],
				specIndex: 0,
				specList: [],
				isVirtual: 1, //是否是虚拟服务 0=实物 1=虚拟
				isVirtualOptions: [{
						name: '实物服务',
						value: 0
					},
					{
						name: '虚拟服务',
						value: 1
					}
				],
				editLevel: -1, //当前所属类目等级
				isHot: 0, //是否是爆款类目
				hotOptions: [{
						name: '非爆款',
						value: 0
					},
					{
						name: '爆款',
						value: 1
					}
				],
				isProfessionalAgency: 0, //是否是可选专业代理 1=可选
				professionalAgencyOptions: [{
						name: '不可选',
						value: 0
					},
					{
						name: '可选',
						value: 1
					}
				],
				productTypeId: 0, //当前编辑的类目ID
				professionalAgencyTitle: '已配置专业代理列表',
				orderMaterialsOptions: [],
				orderMaterials: '',
				orderFlowList: [], //下单步奏
				paymentRequiredOptions: [{
						name: '无需付款',
						value: 0
					},
					{
						name: '需先付款',
						value: 1
					}
				]
			}
		},
		computed: {
			...mapState(['systemConfig', 'userInfo']),
			...mapGetters({
				auth: 'power'
			}),
			isVirtualWord() {
				return {
					0: '发布服务时，需要选择运费模板；下单时，需要填写收货地址、选物流公司',
					1: '虚拟服务无需发货，无需配置运费模板',
				} [this.isVirtual]
			},
			isHotWord() {
				return {
					0: '非爆款类目服务，会员下单普通代理无利润',
					1: '爆款分类，会员下单后，购买该类目的普通代理有利润',
				} [this.isHot]
			}
		},
		mounted() {
			this.$refs.table.load({
				url: '/product_type/list',
				data: {
					parent_id: 0
				}
			});
		},

		methods: {

			searchProfAgency(data) {
				data.is_prof_agency = 1; //查询专业代理
				data.product_type_id = this.productTypeId; //关联类目ID
				this.$refs.profAgencyTable.load({
					url: '/platform_user/list',
					data,
					response: res => {
						this.tempRowData.professional_agency_count = res.total;
						this._resolve(this.tempRowData);
					}
				});
			},

			loadChildren(row, resolve) {
				this.request({
					url: '/product_type/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data || []);
					}
				});
			},

			addHandle(row, resolve) {
				this.editState = false;
				this.editLevel = row ? row.expandData.level + 1 : 0;
				this.productTypeId = 0;
				this._parent = row ? row.data.id : 0;
				this._resolve = data => {
					row ? resolve(data) : this.$refs.table.push(data);
				};
				this.$refs.classifyEdit.clear();
				if (this.editLevel == 0) {
					this.classifyEditTitle = '添加一级类目';
				} else {
					this.classifyEditTitle = '在【' + row.data.type_name + '】类目下添加子类目';
				}
				this.$refs.dialog.open();
			},

			editHandle(row) {
				this.editState = true;
				this.editLevel = row.expandData.level;
				this.productTypeId = row.data.id;
				this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
				this._resolve = data => {
					row.update(data);
				};
				if (this._parent) {
					this.classifyEditTitle = '编辑类目【' + row.expandData.parent.data.type_name + '->' + row.data.type_name +
						'】';
				} else {
					this.classifyEditTitle = '编辑类目【' + row.data.type_name + '】';
				}
				this.$refs.classifyEdit.set(row.data);
				this.$refs.dialog.open();
			},

			editTypeOrderFlow(row) {
                this.request( {
                    url: '/product_type/detail',
                    data: {
                        product_type_id: row.data.id
                    },
                    success: data => {
                        this.showTypeOrderFlow(row,data);
                    }
                })
			},
            showTypeOrderFlow(row,newData) {
                this.editLevel = row.expandData.level;
                this.productTypeId = row.data.id;
                this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
                this._resolve = data => {
                    row.update(data[0]);
                };
                if (this._parent) {
                    this.typeOrderFlowTitle = '配置类目【' + row.expandData.parent.data.type_name + '->' + row.data.type_name +
                            '】下单服务项目、所需材料';
                } else {
                    this.typeOrderFlowTitle = '配置类目【' + row.data.type_name + '】下单服务项目、所需材料';
                }
				this.request({
					url: '/operation/dic/order_materials/options',
					loading: true,
					success: data => {
						this.orderMaterialsOptions = data.map(item => {
							return {
								name: item.name,
								value: item.id
							}
						});
						this.$nextTick(() => {
							this.orderMaterials = newData.order_materials ? newData.order_materials.split(',') : [];
							this.orderFlowList = JSON.parse(newData.order_flow_config || '[]');
							this.$refs.editTypeOrderFlowDialog.open();
						})
					}
				});
            },
			editProfessionalAgency(row) {
				this.productTypeId = row.data.id;
				this._resolve = data => {
				  row.update(data);
				};
				this.$refs.memberUserSelector.open()
			},

			deleteHandle(row) {
				this.$confirm({
					text: '确定要删除当前服务类目【' + row.data.type_name + '】吗2？', // 提示内容,
					buttonName: '确定', // 确定按钮文字
					cancelButton: true, // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product_type/remove',
							data: {
								id: row.data.id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '删除成功',
									icon: 'success'
								});
								row.remove();
							}
						});
					}, // 确定按钮回调
					cancel: () => {}, // 取消按钮回调
				});
			},

			sortHandle(row, type, next) {
				this.request({
					url: '/product_type/sort',
					data: {
						id: row.data.id,
						parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
						type: ['top', 'bottom'].includes(type) ? type : '',
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},

      /**
       * 启禁用
       * @param state true = 启用  false=禁用
       */
      changeTrialDisplay(item,state, stop,next) {
        stop();
        this.$confirm({
          text: '确定将当前类目在体验版小程序中'+(state?"显示":"隐藏")+'？',
          resolve: () => {
            this.request({
              url:'/product_type/edit/trial_display',
              data: {
                product_type_id: item.data.id,
                trial_is_display:state?1:0
              },
              loading: true,
              success: () => {
                this.$message({
                  text: state ? '显示成功' : '隐藏成功',
                  icon: 'success'
                });
                next();
              },
              fail: (code, data, msg) => {
                this.$confirm({
                  text: msg,  // 提示内容,
                  buttonName: '知道了',  // 确定按钮文字
                  cancelButton: false  // 是否显示取消按钮
                });
                return false;
              }
            });
          }
        });
      },

			addChild(stop) {
				stop();
				var data = this.$refs.classifyEdit.serialize();
				if (!data.type_name) {
					this.$message({
						text: '请填写类目名称',
						icon: 'fail'
					});
					return;
				}
				if (this.editLevel == 0 && !data.img_url) {
					this.$message({
						text: '请上传类目图片',
						icon: 'fail'
					});
					return;
				}
				if (this.editLevel == 1 && this.isHot == 1 && !data.sale_price) {
					this.$message({
						text: '请填写爆款类目售价',
						icon: 'fail'
					});
					return;
				}
				if (this.editLevel == 1 && this.isHot == 1 && !data.max_agency_count) {
					this.$message({
						text: '请填写爆款类目限售次数',
						icon: 'fail'
					});
					return;
				}
				if (this.editLevel == 1 && this.isHot == 1 && this.isProfessionalAgency == 1 && !data
					.professional_agency_ratio) {
					this.$message({
						text: '请填写专业代理佣金比例',
						icon: 'fail'
					});
					return;
				}
				this.request({
					url: this.productTypeId ? '/product_type/edit' : '/product_type/add',
					data: Object.assign(data, {
						id: this.productTypeId || 0,
						parent_id: this._parent
					}),
					loading: true,
					success: data => {
						this.$message({
							text: this.productTypeId ? '编辑成功' : '添加成功',
							icon: 'success'
						});
						this.$refs.dialog.close();
						this._resolve(data);
					}
				});
			},

			specConfig(row) {
				this._specConfigId = row.data.id;
				this.request({
					url: '/product_type/specs',
					data: {
						product_type_id: row.data.id
					},
					loading: true,
					success: data => {
						this.$refs.specConfigDialog.open();

						data.is_support_sku_img = data.is_support_sku_img || 0;
						this.$refs.specConfig.set(data);
						this.specList = Array.from(data ? data.spec_list : [], spec => {
							return {
								name: spec.group_name,
								image: spec.group_img_flag == 2,
								itemList: Array.from(spec.children, item => {
									return {
										id: item.group_id,
										value: item.group_value
									}
								})
							}
						});
						if (!this.specList.length) {
							this.addSpec();
						}
					}
				});
			},

			specNameVerify(spec, index) {
				if (this.specList.find((item, i) => {
						return index != i && item.flow_name == spec.name;
					})) {
					this.$message({
						text: '规格名不能重复，请重新输入'
					});
					spec.name = '';
				}
			},

			specImageCheck(state, spec) {
				if (state) {
					let crt = this.specList.find(item => item.image && item != spec);
					crt && (crt.image = false);
				}
				spec.image = state;
			},

			specConfigHandle(stop) {
				stop();

				this.$refs.specConfig.submit({
					url: '/product_type/save_specs',

					rule: {
						spec: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									if (!this.specList[i].name) {
										state = false;
										break;
									}
								}
								return state;
							},
							word: '请完善规格名'
						}],

						spec_value: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									for (let j in this.specList[i].itemList) {
										if (!this.specList[i].itemList[j].value) {
											state = false;
											break;
										}
									}
								}
								return state;
							},
							word: '请完善规格值'
						}]
					},

					dataFormatter: data => {
						let specList = [];
						this.specList.forEach((spec, i) => {
							(spec.itemList.length ? spec.itemList : [{}]).forEach((item, j) => {
								specList.push({
									product_type_id: this._specConfigId,
									group_name: spec.name,
									group_value: item.value,
									group_img_flag: spec.image ? 2 : 1,
									group_level: i + 1,
									sort_id: j + 1
								});
							});
						});

						data.product_type_id = this._specConfigId;
						data.spec_list = specList;

						return data;
					},

					success: data => {
						this.$message({
							text: '规格配置保存成功',
							icon: 'success'
						});
						this.$refs.specConfigDialog.close();
					}
				});
			},

			addSpec() {
				if (this.specList.length == 3) {
					this.$message({
						text: '最多只能添加三个规格项'
					});
					return;
				}
				var item = {
					name: '',
					itemList: []
				};
				this.specList.push(item);
			},

			sortSpec(index, type) {
				if ((type == 'up' && index == 0) || (type == 'down' && index == this.specList.length - 1)) return;
				var spec = this.specList.splice(index, 1)[0];
				this.specList.splice(type == 'up' ? index - 1 : index + 1, 0, spec);
			},

			removeSpec(index) {
				this.specList.splice(index, 1);
			},

			addSpecItem(spec) {
				var id = `spec${this.specIndex++}`;

				spec.itemList.push({
					id,
					value: ''
				});
			},

			specValueVerify(spec, list) {
				if (list.find(item => {
						return item.id != spec.id && item.value == spec.value;
					})) {
					this.$message({
						text: '规格值不能重复，请重新输入'
					});
					spec.value = '';
				}
			},

			removeItem(spec, index) {
				spec.itemList.splice(index, 1);
			},

			//发布
			releaseHandle(row, resolve) {
				this.$confirm({
					text: '确定要发布吗？', // 提示内容,
					buttonName: '确定', // 确定按钮文字
					cancelButton: true, // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product_type/release',
							data: {},
							loading: true,
							success: data => {
								this.$message({
									text: '发布成功',
									icon: 'success' // 图标（success：成功，fail：失败）
								});
							}
						});
					}, // 确定按钮回调
					cancel: () => {}, // 取消按钮回调
				});
			},

			//选择会员回调方法
			selectHandle(list) {
				var user_ids = Array.from(list, item => item.platform_user_id);
				this.request({
					url: '/product_type/professional_agency/edit',
					data: {
						product_type_id: this.productTypeId,
						user_ids: user_ids
					},
					loading: true,
					success: data => {
						this.$message({
							text: '操作成功',
							icon: 'success' // 图标（success：成功，fail：失败）
						});
                    this._resolve(data);
						this.$refs.dialog.close();
					}
				});
			},

			showProfAgency(row) {
				this.professionalAgencyTitle = '类目【' + row.expandData.parent.data.type_name + '->' + row.data.type_name +
					'】已配置专业代理列表';
				this.productTypeId = row.data.id;
				this.searchProfAgency({});
				this.tempRowData = row.data;
                this._resolve = data => {
                  row.update(data);
                };
				this.$refs.professionalAgencyDialog.open();
			},

			removeProfAgency(data) {
				this.$confirm({
					text: `确定要将该专业代理移除吗？`,
					resolve: () => {
						this.request({
							url: '/product_type/professional_agency/remove',
							data: {
								product_type_id: this.productTypeId,
								user_id: data.platform_user_id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '操作成功',
									icon: 'success' // 图标（success：成功，fail：失败）
								});
								this.$refs.profAgencyTable.update();
							}
						});
					}
				});
			},
			addOrderFlow() {
				if (this.orderFlowList.length >= 20) {
					this.$message({
						text: '最多允许添加20个服务项目',
						icon: 'fail'
					});
					return false;
				}
				var obj = {};
				obj.id = this.orderFlowList.length + 1;
				obj.name = ''
				obj.ratio = ''
				if (this.orderFlowList.length == 0) {
					obj.payment_required = 1;
				} else {
					obj.payment_required = 0;
				}
				this.orderFlowList.push(obj);
			},
			//排序
			changePaymentRequired(row) {
				if (row.data.payment_required == 0) {
					row.data.ratio = '';
                    row.data.flow_ratio = '';
				}
			},
			//排序
			sortOrderFollowHandle(row, type, next) {
				next();
			},
			//编辑下单信息响应方法
			editOrderFlowHandle(stop) {
				stop();
				if (!this.orderMaterials.length) {
					this.$message({
						text: '请填写类目服务下单所需材料',
						icon: 'fail'
					});
					return;
				}
				if (!this.orderFlowList || this.orderFlowList.length <= 0) {
					this.$message({
						text: '请填写类目服务下单的服务项目',
						icon: 'fail'
					});
					return;
				}
				var name_list = Array.from(this.orderFlowList, item => {
					if (item.flow_name && item.flow_name != '')
						return item.flow_name
				});
				if (name_list.length < this.orderFlowList.length) {
					this.$message({
						text: '请输入服务项目名称',
						icon: 'fail'
					});
					return false;
				}
				var flag = false;
				var ratioTotal = 0;
				for (var i = 0; i < name_list.length; i++) {
					var obj1 = name_list[i];
					for (var j = 0; j < name_list.length; j++) {
						var obj2 = name_list[j];
						if (i != j && obj1 && obj2 && obj1 != '' && obj2 != '' && obj1 == obj2) {
							flag = true;
						}
					}
				}
				if (flag) {
					this.$message({
						text: '存在重复的服务项目名称，请检查',
						icon: 'fail'
					});
					return false;
				}
				for (var k = 0; k < this.orderFlowList.length; k++) {
					var item = this.orderFlowList[k];
					if (k == 0 && (item.payment_required == 0 || parseFloat(item.flow_ratio || 0) <= 0)) {
						this.$message({
							text: '首个服务项目必须标记为“需先付款”，且付款比例不能是0%',
							icon: 'fail'
						});
						return false;
					}
					ratioTotal = ratioTotal + parseFloat(item.flow_ratio || 0);

				}
				this.orderFlowList.map(item => {});
				if (ratioTotal != 100) {
					this.$message({
						text: '所有服务项目的付款比例总和必须是100%',
						icon: 'fail'
					});
					return false;
				}
				this.request({
					url: '/product_type/edit/order/config',
					data: {
						id: this.productTypeId,
						order_materials: this.orderMaterials.join(','),
						order_flow_config: this.orderFlowList
					},
					loading: true,
					success: data => {
						this.$message({
							text: '保存成功',
							icon: 'success'
						});
						this.$refs.editTypeOrderFlowDialog.close();
						this._resolve(data);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.spec {
		position: relative;
		padding: 15px 17px;
		background: #F9F8FB;

		&:nth-child(n+2) {
			margin-top: 16px;
		}

		&-list {
			.c-button {
				margin-top: 16px;
			}
		}

		&-label {
			margin-right: 8px;
			line-height: 36px;
			font-size: 13px;
			white-space: nowrap;
			color: #444;
		}

		&-handle {
			position: absolute;
			right: 0;
			top: 0;

			&-item {
				width: 24px;
				margin-left: 5px;
				line-height: 24px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				background: #aaa;

				&:hover {
					background: #999;
				}
			}
		}

		&-name {
			width: 130px;
			height: 34px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: 14px;
			font-size: 13px;
			background: #fff;
		}

		&-item {
			width: 128px;
			height: 30px;
			border: 1px solid #ddd;
			padding: 0 5px;
			margin-top: 12px;
			margin-right: 12px;
			background: #fff;

			&-value {
				font-size: 13px;
			}

			&-remove {
				margin-left: 5px;
				font-size: 16px;
				color: #C70000;
			}
		}

		.c-button {
			margin-top: 16px;
		}
	}
</style>